import * as React from 'react';
import { IconActionSort16 } from '@cian/ui-kit-design-tokens/icons';
import { IBaseSelectProps } from '../../types/select';
import { SelectLabel } from '../SelectLabel';
import * as styles from './styles.css';

export function MobileSelect({ value, values, onChange }: IBaseSelectProps) {
  const currentValue = values.find(({ id }) => value === id);
  const onValueChange = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => onChange(Number(event.target.value)),
    [onChange],
  );

  return (
    <div className={styles['container']}>
      <SelectLabel icon={<IconActionSort16 color="icon-main-default" />}>
        {currentValue?.text || 'Не выбрано'}
      </SelectLabel>
      <select className={styles['select']} value={value} onChange={onValueChange}>
        {values.map(({ id, text }) => (
          <option key={id} value={id}>
            {text}
          </option>
        ))}
      </select>
    </div>
  );
}
